import { FetchArgs, retry } from "@reduxjs/toolkit/query";
import { ZodSchema } from "zod";
import { TransactionIdScopeType } from "../../../../enums/transactionIdScopeType";
import { TBaseQuery } from "../../../../models/baseQueries/baseQuery";

export const staggeredRetryBaseQuery = (baseQuery: TBaseQuery, maxRetries: number) =>
  retry(
    async (
      args: string | FetchArgs,
      api,
      extraOptions: { dataSchema?: ZodSchema; transactionIdScopeType?: TransactionIdScopeType }
    ) => {
      const result = await baseQuery(args, api, extraOptions);
      const responseErrStatus = result.error?.status;
      if (responseErrStatus === 401 || responseErrStatus === 400) {
        retry.fail(result.error);
      }

      return result;
    },
    {
      maxRetries: import.meta.env.MODE === "test" ? 0 : maxRetries,
    }
  );
